import { commonConstants } from '@config//constants/common';
import { Constants } from '@config/constants/constants.interface';

export const constantsPattern: Constants = {...commonConstants};
